/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { Badge } from "antd";
import { Collapse, Form, Flex, Row, Col, Space, Card, message } from "antd";
import { Input, Button, Table, Typography, DatePicker } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { accessColumn } from "./model";
import useAccessPageState from "../../../hooks/useAccessPageState";
// import OptionService from "../../../service/ERP/Options.service";
import dayjs from "dayjs";
import JobOrderservice from "../../../service/ERP/JobOrder.service.js";
import ModalJODeliveryNote from "../../../components/modal/ERP/job-order/ModalJODeliveryNote";
import ModalJoShipped from "../../../components/modal/ERP/job-order/ModalJoShipped";
import useColumnSettings from "../../../hooks/useColumnSettings";
// const opService = OptionService();
const joservice = JobOrderservice();
const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};
const JobOrderAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const [dnModal, setDnModal] = useState({ show: false, jocode: null });
  /* modal บันทึกจำนวนที่ส่งแล้ว (แยกจากหน้าจอแก้ JO เพื่อไม่ให้ออกเวอร์ชันใหม่) */
  const [shipModal, setShipModal] = useState({ show: false, jocode: null });
  const { RangePicker } = DatePicker;
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      if (!!data?.jodate) {
        const arr = data?.jodate.map((m) => dayjs(m).format("YYYY-MM-DD"));
        const [jodate_form, jodate_to] = arr;

        //data.dndate = arr
        Object.assign(data, { jodate_form, jodate_to });
      }
      joservice
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => {
          const { data } = res.data;

          setAccessData(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    };

    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      runSearch(forcedValues);
      return;
    }

    form.validateFields().then((v) => {
      runSearch(v);
    });
  };

  const handleClear = () => {
    clearState();
    form.resetFields();

    const nextPagination = restoreDefaultPagination();

    handleSearch({}, nextPagination);
  };

  const hangleAdd = () => {
    navigate("manage/create", {
      state: {
        config: {
          ...mngConfig,
          title: "Create Job Order",
          action: "create",
        },
      },
    });
  };

  const handleSave = (data) => {
    // setManageConfig({...manageConfig, title:"แก้ไข Sample Request", action:"edit", code:data?.srcode});
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Edit Job Order",
          action: "edit",
          code: data?.jocode,
        },
      },
    });
  };

  const handleView = (data) => {
        navigate("view", { state: { config: {...mngConfig, title:"View", code:data?.jocode} } } );
    };   

  const init = async () => {
    getData({});
  };

  useEffect(() => {
    const restored = restoreState();

    handleSearch(restored?.searchValues ?? null, restored?.tablePagination);
    return async () => {
      //console.clear();
    };
  }, []);

  const getData = () => {
    handleSearch();
  };

  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      bordered={false}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <>
              <br />
              <Form form={form} layout="vertical" autoComplete="off">
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item
                      label="JO Code"
                      name="jocode"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter Jo Code" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="Job Order Date." name="jodate">
                      <RangePicker
                        placeholder={["From Date", "To date"]}
                        style={{ width: "100%", height: 40 }}
                        onChange={handleSearch}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="Customer Name" name="cusname">
                      <Input placeholder="Enter Customer Name." onChange={handleSearch}/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="PG Name" name="pg_name">
                      <Input placeholder="Enter PG Name." onChange={handleSearch}/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="FG Name" name="fg_name">
                      <Input placeholder="Enter FG Name." onChange={handleSearch}/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="Brand" name="brand">
                      <Input placeholder="Enter Brand." onChange={handleSearch}/>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    {/* Ignore */}
                  </Col>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        icon={<SearchOutlined />}
                        onClick={() => handleSearch()}
                      >
                        ค้นหา
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        danger
                        icon={<ClearOutlined />}
                        onClick={() => handleClear()}
                      >
                        ล้าง
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
          showArrow: false,
        },
      ]}
    />
  );

  const handlePrint = (recode) => {
    const newWindow = window.open("", "_blank");
    newWindow.location.href = `/jo-print/${recode?.jocode}/${recode?.version}`;
  };

  const handlePrintInvoice = (recode) => {
    const newWindow = window.open("", "_blank");
    newWindow.location.href = `/jo-invoice-print/${recode?.jocode}/${recode?.version}`;
  };

  const handleDeliveryNote = (record) => {
    setDnModal({ show: true, jocode: record?.jocode });
  };

  const handleShipped = (record) => {
    setShipModal({ show: true, jocode: record?.jocode });
  };

  const handleApprove = async (record, approveType) => {
    try {
      await joservice.approve({
        jocode: record?.jocode,
        approve_type: approveType,
      });
      message.success("อัปเดตสถานะสำเร็จ");
      handleSearch();
    } catch (err) {
      const data = err?.response?.data;
      message.error(data?.message || "อัปเดตสถานะไม่สำเร็จ");
    }
  };

  const allColumns = accessColumn({
    handleApprove,
    handlePrint,
    handlePrintInvoice,
    handleView,
    handleDeliveryNote,
    handleShipped,
  });

  /* คอลัมน์ที่แสดง ผู้ใช้เลือกเองได้ ระบบจำไว้ใน cookie ของเครื่องนี้ */
  const { columns: column, settingsButton } = useColumnSettings(
    "joborder_access_cols",
    allColumns
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            List of Job Order
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end">
          {settingsButton}
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            Create Product
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="joborder-access">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        {FormSearch}
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="product_code"
                columns={column}
                dataSource={accessData}
                scroll={{ x: 'max-content' }} 
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>

      {dnModal.show && (
        <ModalJODeliveryNote
          show={dnModal.show}
          close={() => setDnModal({ show: false, jocode: null })}
          jocode={dnModal.jocode}
        />
      )}

      {shipModal.show && (
        <ModalJoShipped
          show={shipModal.show}
          close={() => setShipModal({ show: false, jocode: null })}
          jocode={shipModal.jocode}
          /* บันทึกเสร็จให้รีเฟรชตาราง ตัวเลข "ส่งแล้ว" กับสถานะจะได้ตรง */
          onSaved={() => handleSearch()}
        />
      )}
    </div>
  );
};

export default JobOrderAccess;
